import React, { useState } from 'react';
import CabinetOverviewSearchBar from './CabinetOverviewSearchBar';
import CabinetOverviewTable from './CabinetOverviewTable';
import { RentCabinetProvider } from './components/RentCabinetContext';
import { initBookmark } from './staticData';

const CabinetOverviewPage = props => {
	const { dialogRef, refreshRef } = props;
	const [bookmark, setBookmark] = useState(initBookmark);
	const [tableData, setTableData] = useState({});

	const setBookmarkNum = num => setBookmark(pre => ({ ...pre, pageIndex: num }));

	const childContext = {
		tableData,
		setTableData,
		bookmark,
		setBookmarkNum,
		refresh: refreshRef,
		setRefresh: el => (refreshRef.current = el),
		dialogRef
	};

	return (
		<RentCabinetProvider value={childContext}>
			<CabinetOverviewSearchBar className="mb-4" />
			<CabinetOverviewTable />
		</RentCabinetProvider>
	);
};

export default CabinetOverviewPage;
